import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Modal, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { FaRegCircleCheck, FaWhatsapp } from 'react-icons/fa6'; // FaRupeeSign removed
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SlArrowLeft } from 'react-icons/sl';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import '../../../jsx/Dashborad/dashboard.css';
import CivilButton from '../../ReusableComponent/CIVIL/CivilButton/CivilButton';
import DomainSpecificSubjectsPaymentModal from './DomainSpecificSubjectsPaymentModal';

function DomainSpecificSubjectsHome() {
    const navigate = useNavigate();
    const alert = useAlert();
    const location = useLocation();

    const [open, setOpen] = useState(false);
    const [openPaymentProccessingModal, setPaymentProccessingModal] = useState(false);
    const email = localStorage.getItem("authtoken")
    const [subjects, setSubjects] = useState([]);
    // const [tests, setTests] = useState([]);
    const [subjectSpecificData, setSubjectSpecificData] = useState({});
    const [checkedSubjects, setCheckedSubjects] = useState([]);
    const [openPaymentSuccessModal, setPaymentSuccessModal] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const orders = checkedSubjects?.filter(data => data.checked && data.Price);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response1 = await axios.get(BASE_URL + `/cuet/user/subjects/Section-II`);
                setSubjects(response1.data.data);
                // setSelectedSubject(response1.data.data[0]);
                // const response2 = await axios.get(BASE_URL + `/cuet/user/testplans/Section-II`);
                // setTestPlans(response2?.data?.data);
                // setSelectedTest(response2?.data?.data[0]);
                const response3 = await axios.get(BASE_URL + `/cuet/user/subject-specific-data/Section-II`);
                setSubjectSpecificData(response3?.data?.data[0]);
            } catch (error) {
                console.log(error);
            }

        }
        fetchInitialData()
    }, []);

    useEffect(() => {
        setCheckedSubjects(subjects.filter(data => data.checked && data.Price));
        // setTests(new Array(selectedTest.TestCount).fill(1));
    }, [subjects]);



    const price = (checkedSubjects || [])
        .filter(data => typeof data.Price === 'number' && typeof data.Discount === 'number')
        .reduce((acc, curr) => acc + curr.Price, 0);

    const totalPayable = (checkedSubjects || [])
        .filter(data => typeof data.Price === 'number' && typeof data.Discount === 'number')
        .reduce((acc, curr) => acc + (curr.Price - (curr.Price * curr.Discount / 100)), 0);


    const handleEnroll = () => {
        if (checkedSubjects?.filter(data => data.checked && data.Price).length < 1) {
            alert.show("Please select at least one subject with valid test plan");
            return;
        }
        if (email) {
            setOpen(true);
        } else {
            navigate('/login');
        }
    }

    const handleSelectSubject = (subject) => {
        let copy = [...subjects];
        let selectedSubject = copy.find((data) => data.Sn == subject.Sn);
        if (selectedSubject) {
            selectedSubject.checked = !selectedSubject.checked;
            setSubjects(copy);
        }
    };
    const handlePlanSelect = (subjectId, plan) => {
        let copy = [...subjects];
        let selectedSubject = copy.find((data) => data.Sn === subjectId);

        if (!selectedSubject || !selectedSubject.checked) return; // prevent change if subject not found or not checked

        selectedSubject.TestCount = plan?.TestCount || 0;
        selectedSubject.Price = plan?.Price || 0;
        selectedSubject.Discount = plan?.Discount || 0;

        setSubjects(copy);
    };

    return (
        <>
            <Helmet>
                {/* <title>{"CUET | Seciton-II"}</title> */}
                <title>{"CUET | Domain-Specific Subjects"}</title>
                {/* <meta name="description" content={`${testSeriesData.MetaDescription}`}></meta> */}
            </Helmet>
            {/* Civil Test Page Start */}
            <div className='Dashboard-background'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-12 col-sm-12 dashboardmain-left p-3'>
                            <div className='dashboardleft-background'>
                                <div className='dash1'>
                                    <img src={subjectSpecificData?.Thumbnail} alt={"..."} className='dash2-img' />
                                </div>
                                <div className='dash2'>
                                    <div className="d-grid gap-2">
                                        <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, selecteSection: 'Domain-Specific Subjects', moduleName: 'cuet' }} className="btn d-flex align-items-center justify-content-center btn-orange fw-bold py-3" type="button" style={{ letterSpacing: '0.5px', fontSize: '1.05rem' }}>Dashboard</Link>
                                        <button
                                            onClick={handleEnroll}
                                            className="btn btn-orange py-2 px-3 d-flex flex-column align-items-center justify-content-center"
                                            type="button"
                                        >
                                            {checkedSubjects?.filter(data => data.checked && data.Price).length > 0 ? (
                                                <>
                                                    <div className='d-flex align-items-center justify-content-center flex-wrap mb-1' style={{ gap: "10px", opacity: 0.9 }}>
                                                        <span className='text-decoration-line-through text-uppercase' style={{ fontSize: '1rem' }}>
                                                            FEE ₹{price || 500}
                                                        </span>
                                                        <span className='fw-bold text-uppercase' style={{ fontSize: '1rem', background: 'rgba(255,255,255,0.2)', padding: '2px 8px', borderRadius: '4px' }}>
                                                            DISCOUNT ₹{(price - totalPayable) > 0 ? Math.ceil(price - totalPayable).toLocaleString("en-IN") : 100}
                                                        </span>
                                                    </div>
                                                    <div className='fw-bold text-uppercase' style={{ fontSize: '1.1rem', letterSpacing: '1px' }}>
                                                        ₹{totalPayable > 0 ? totalPayable.toLocaleString("en-IN") : 400} - {totalPayable < 1 ? 'ENROLL FOR FREE' : 'ENROLL NOW'}
                                                    </div>
                                                </>
                                            ) : (
                                                <div className='fw-bold text-uppercase' style={{ fontSize: '1.2rem', letterSpacing: '1px', padding: '10px 0' }}>
                                                    ENROLL NOW
                                                </div>
                                            )}
                                        </button>

                                        <Link to="https://api.whatsapp.com/send?phone=919818333201" target='_blank' className="btn d-flex align-items-center justify-content-center btn-whatsapp fw-bold py-3" type="button" style={{ letterSpacing: '0.5px', fontSize: '1.05rem' }}><FaWhatsapp className='me-1 fs-4' /> WHATSAPP 9818333201</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-9 col-md-12 col-sm-12'>
                            <div className="d-flex justify-content-between align-items-center p-2 py-1 mb-3 bg-light border rounded shadow-sm">
                                <button
                                    className="btn btn-sm"
                                    style={{
                                        backgroundColor: '#17a2b8',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        padding: '4px 12px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => navigate(-1)}
                                >
                                    <SlArrowLeft /> Back
                                </button>
                                <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>Domain-Specific Subjects</h2>
                                <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, selecteSection: 'Domain-Specific Subjects', moduleName: 'cuet' }} style={{ textDecoration: 'none', color: '#17a2b8', fontWeight: 'bold' }}>Dashboard</Link>
                            </div>
                            <CivilButton overView={subjectSpecificData?.Description} sectionIIsubjects={subjects} componentName="Domain-Specific Subjects" ExamType='Section-II' selectSectionII_Subject={handleSelectSubject} selectSectionII_Plan={handlePlanSelect} />
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={open} centered className="animate__animated animate__fadeIn mobileyoutube">
                <DomainSpecificSubjectsPaymentModal setOpen={setOpen} Amount={totalPayable} ExamType="Section-II" /* TestCount={selectedTest.TestCount} */ orders={orders} setPaymentProccessingModal={setPaymentProccessingModal} setPaymentSuccessModal={setPaymentSuccessModal} setTransactionId={setTransactionId} />
            </Modal>
            <Modal show={openPaymentProccessingModal} top backdrop="static" dialogClassName="custom-modal-width">
                <div className="modal-content" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className="modal-body" style={{ padding: "2rem" }}>
                        <div className="mb-3 d-block text-center">
                            <Spinner
                                animation="border"
                                className="mt-5 mb-3"
                                size="xl"
                                style={{ width: "200px", height: "200px", color: "#ff2f00" }}

                            />
                            <h5
                                className="modal-title mb-5"
                                id="exampleModalLabel"
                                style={{ color: "#17a2b8", fontFamily: "Arial, sans-serif" }}
                            >
                                Saving Order Details. This may take a moment...
                            </h5>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal show={openPaymentSuccessModal} top backdrop="static" dialogClassName="" size="lg" centered>
                <div className="" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className='p-5 py-3 d-flex justify-content-center align-items-center' >
                        <div className='text-black text-center'>
                            <FaRegCircleCheck className='text-orange' style={{ fontSize: "15vmax" }} />
                            <h1 className='py-2 fw-bold text-success'>Payment Successful</h1>
                            <h4 className='text-info'>Your order has been placed Successfully</h4>
                            <h6 > <span style={{ fontWeight: "700" }}>Program Name</span> : Domain-Specific Subjects : ({orders?.map((obj, index) => {
                                if (index == (orders?.length || 0) - 1) {
                                    return <span key={index}>{obj?.SubjectType}</span>
                                } else {
                                    return <span key={index}>{obj?.SubjectType + ", "}</span>
                                }
                            })})</h6>
                            <h6 ><span style={{ fontWeight: "700" }}>Payment ID</span> : {transactionId}</h6>

                            {/* <h6>Payment ID:</h6> */}
                            {/* <h6>{paymentdetail[0].TranscationID}</h6> */}
                            <div className='p-3 d-flex justify-content-around flex-column w-75 mx-auto '>
                                <Link to={`/StudentDashboard`} state={{ prePath: location.pathname, selecteSection: 'Domain-Specific Subjects', moduleName: 'cuet' }} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4' >
                                    Go to My Dashboard
                                </Link>
                                <Link onClick={() => setPaymentSuccessModal(false)} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4 my-2' >
                                    Close
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* Civil Test Page End */}
        </>
    )
}

export default DomainSpecificSubjectsHome;